import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { GameSettingsKeys, useGameSetting } from '../../core/util/UseGameSetting';
import { GameIndexContext, TestingModeContext } from '../../core/util/Context';
import { Contact3DGameWindow } from './Contact3DGameWindow';
import { Contact3DLobbyWindow } from './Contact3DLobbyWindow';
import { useGameLifecycleStage } from '../../../core/game/client/GameContextHooks';
import { useCallback, useContext } from 'react';
import { clearGame } from '../../core/util/GameContextProvider';
export const Contact3DWindow = (props) => {
    const { gameId } = props;
    const gameIndex = useContext(GameIndexContext);
    const isTestingMode = useContext(TestingModeContext);
    const [renderingMode] = useGameSetting(`${GameSettingsKeys.RenderingMode}${gameIndex}`);
    // const debugOverlayWrapper = useValue('DebugOverlayWrapper', () => new DebugOverlayWrapper(new DebugOverlayWrapperInit()), []);
    // const chatInputWrapper = useValue('ChatInputWrapper', () => new ChatInputWrapper(new ChatInputWrapperInit()), []);
    // const chatInput = useValue('ChatInput', () => new ChatInput({
    //     chatInputWrapper,
    // }), []);
    const gameLifecycleStage = useGameLifecycleStage();
    const wholeScreenScale = isTestingMode ? 0.5 : 1;
    const translate = getTestingModeTranslate(isTestingMode, gameIndex);
    const closeGameSession = useCallback(() => {
        clearGame(gameIndex);
        //gameSession.close();
    }, []);
    return (_jsxs("div", { style: { position: 'absolute', scale: `${wholeScreenScale}`, width: '100%', height: '100%', translate }, children: [gameLifecycleStage === 'Lobby' &&
                _jsx(Contact3DLobbyWindow, { gameId: gameId, closeGameSession: closeGameSession }), gameLifecycleStage === 'Ingame' &&
                _jsx(Contact3DGameWindow, { renderingMode: renderingMode, gameIndex: gameIndex, isTestingMode: isTestingMode })] }));
};
function getTestingModeTranslate(isTestingMode, gameIndex) {
    if (!isTestingMode) {
        return undefined;
    }
    const xTranslate = gameIndex % 2 === 0 ? '-25%' : '25%';
    const yTranslate = Math.floor(gameIndex / 2) === 0 ? '-25%' : '25%';
    return `${xTranslate} ${yTranslate}`;
}
//# sourceMappingURL=Contact3DWindow.js.map